<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="10"
        offset-md="1"
        lg="10"
        offset-lg="1"
        xl="10"
        offset-xl="1"
      >
        <template v-if="showSkeleton">
          <v-skeleton-loader
            class="mb-6"
            type="card-avatar, article, list-item-avatar, list-item-avatar"
          ></v-skeleton-loader>
        </template>
        <template v-if="!showSkeleton && courses != null">
          <v-row class="pt-5">
            <v-col cols="12">
              <v-toolbar flat dense color="#fafafa">
                <v-toolbar-title class="contentHeader"
                  >My Courses</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-menu offset-y left>
                  <template v-slot:activator="{ on }">
                    <v-btn text :color="$buttonColor" v-on="on">
                      <v-icon left>{{
                        sortOrder == 1
                          ? "far fa-sort-amount-up-alt"
                          : "far fa-sort-amount-down-alt"
                      }}</v-icon
                      >Sort
                    </v-btn>
                  </template>

                  <div class="white">
                    <div class="pa-4 pb-0">
                      <v-btn-toggle
                        mandatory
                        v-model="sortOrder"
                        @change="changeSortOrder"
                      >
                        <v-btn small>Ascending</v-btn>
                        <v-btn small>Descending</v-btn>
                      </v-btn-toggle>
                    </div>
                    <v-divider class="my-2"></v-divider>
                    <v-list tile class="pt-0" dense min-width="240px">
                      <template v-for="(item, index) in sortByOptions">
                        <v-list-item
                          :key="`sortBy_${index}`"
                          @click="updateUrl('sortby', item)"
                          :class="{
                            'primary--text v-list-item--active':
                              (sortBy || null) == item.param,
                          }"
                        >
                          <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item>
                        <v-divider
                          v-if="index != sortByOptions.length - 1"
                          :key="`div_sortBy_${index}`"
                        ></v-divider>
                      </template>
                    </v-list>
                  </div>
                </v-menu>
                <!-- <div class="py-2 ml-3 mr-2 fill-height">
                  <v-divider vertical></v-divider>
                </div>
                <v-menu offset-y left>
                  <template v-slot:activator="{ on }">
                    <v-btn text :color="$buttonColor" v-on="on">
                      <v-avatar size="24" class="grey lighten-2 mr-2">
                        <span class="overline">{{
                          itemsPerPage == -1 ? "+" : itemsPerPage
                        }}</span> </v-avatar
                      >Limit
                    </v-btn>
                  </template>
                  <div class="pa-0">
                    <v-list dense>
                      <template v-for="(item, index) in pagingOptions">
                        <v-list-item
                          :key="`ipp_${index}`"
                          @click="updateUrl('ipp', item)"
                          :class="{
                            'primary--text v-list-item--active':
                              item == itemsPerPage,
                          }"
                        >
                          <v-list-item-title>{{
                            item == -1 ? "All" : item
                          }}</v-list-item-title>
                        </v-list-item>
                        <v-divider
                          v-if="index != pagingOptions.length - 1"
                          :key="`div_ipp_${index}`"
                        ></v-divider>
                      </template>
                    </v-list>
                  </div>
                </v-menu> -->
              </v-toolbar>
            </v-col>
          </v-row>

          <v-row>
            <template v-for="item of courses">
              <v-col
                cols="12"
                sm="6"
                lg="4"
                xl="3"
                class="pr-5"
                :key="`course_${item._id}`"
                @click="navigate(item)"
              >
                <v-hover v-slot:default="{ hover }">
                  <v-card
                    class="recCourseCustomCard hoverable card-growable"
                    elevation="0"
                    ripple=""
                    @click="navigate(item)"
                  >
                    <v-img
                      class="recCourseImage"
                      max-width="100%"
                      width="auto"
                      :src="item.image"
                      :lazy-src="item.image"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-sheet
                            width="100%"
                            height="100%"
                            color="grey lighten-3"
                            class="d-flex justify-center"
                          >
                            <v-icon x-large color="grey lighten-1"
                              >mdi mdi-image-area</v-icon
                            >
                          </v-sheet>
                        </v-row>
                      </template>
                    </v-img>
                    <v-row>
                      <v-col>
                        <div
                          :style="{
                            color: `${$themeColor}`,
                            fontSize: `13px`,
                            fontWeight: `500`,
                            marginTop: `8px`,
                            marginBottom: `8px`,
                          }"
                          v-text="item.categories[0].title"
                        ></div>
                        <div class="myCourseTitle">
                          {{ item.title }}
                        </div>
                        <div class="recInstructor">
                          {{ item.owner_by_students[0]._id.displayName }}
                        </div>
                        <div class="d-flex" style="align-items: center">
                          <div>
                            <v-rating
                              half-increments
                              half-icon="fas fa-star-half-alt"
                              background-color="grey"
                              color="amber"
                              readonly
                              dense
                              x-small
                              :value="item.rating"
                            ></v-rating>
                          </div>
                          <div class="ml-2 flex-grow-1">
                            <p class="mb-0 body-2">{{ item.rating }}</p>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-hover>
              </v-col>
            </template>
          </v-row>

          <v-row class="pt-5" justify="end">
            <v-pagination
              v-model="page"
              :length="pageCount"
              @input="changePage"
              :color="$buttonColor"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
            ></v-pagination>
          </v-row>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    courses: null,
    showSkeleton: true,
    sort: "created_at",
    sortBy: "created_at",
    sortby: 1,
    limit: 9,
    page: 1,
    pageCount: 0,
    sortByOptions: [
      {
        param: "created_at",
        text: "Created",
      },
      {
        param: "title",
        text: "Title",
      },
      {
        param: "rating",
        text: "Rating",
      },
    ],
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.fetch();
    },
    async changePage(page) {
      this.page = page;
      await this.init();
    },
    updateUrl(flag, value) {
      if (this.reloadMode) {
        let qs = this.$utility.vueRouterQueryToJson(this.$route.query);
        if (flag == "sortorder") {
          qs.sortby = this.$utility.getApiSortOrder(value);
        } else if (flag == "sortby") {
          qs.sort = value.param;
          this.sortBy = value.param;
        } else if (flag == "ipp") {
          qs.limit = value;
        } else if (flag == "page") {
          qs.page = value;
        } else if (flag == "category") {
          if (value != null) {
            qs.category = value;
          } else {
            delete qs.category;
          }
        } else if (flag == "grade") {
          if (value != null) {
            qs.grade = value;
          } else {
            delete qs.grade;
          }
        } else if (flag == "skill") {
          if (value != null) {
            qs.skill = value;
          } else {
            delete qs.skill;
          }
        }
        this.$nextTick(() => {
          this.$router
            .replace({
              query: qs,
            })
            .catch(() => {
              // do nothing
              // window.location = "/course?" + this.$utility.routerQueryStringToUrlParams(qs);
            });
        });
      } else {
        if (flag == "sortorder") {
          // this.sortOrder = value;
        } else if (flag == "sortby") {
          this.sortBy = value;
        } else if (flag == "ipp") {
          this.itemsPerPage = value;
        }
        this.fetch();
      }
    },
    fetch() {
      this.profile = null;
      this.showSkeleton = true;
      console.log("fetch -> this.sortBy", this.sortBy);
      let stdParams = {
        sort: this.sortBy,

        sortby: this.sortby,
        page: this.page,
        limt: this.limit,
      };
      this.$http
        .get(
          `${
            this.$store.state.api
          }/mylib/user/course/v2?${this.$utility.routerQueryStringToUrlParams(
            stdParams
          )}`
        )
        .then((resp) => {
          if (resp.data.status == true) {
            this.courses = resp.data.result.data;
            this.pageCount = resp.data.result.maxPage;
          } else {
            this.courses = null;
          }
        })
        .catch((err) => {
          this.courses = null;
        })
        .finally(() => {
          this.showSkeleton = false;
        });
    },
    navigate(item) {
      this.$router.push({
        name: "course_detail",
        params: {
          id: item._id,
        },
      });
    },
  },
};
</script>
<style scoped>
.contentHeader {
  font-size: 26px;
  font-weight: bold;
  color: #000000;
}

.recCourseCustomCard {
  border-radius: 4px;
  border: solid 1px #dcdcdc;
  background-color: #ffffff;
  padding: 15px 15px 15px 15px;
}

.myCourseCatagory {
  font-size: 13px;
  font-weight: 500;
  color: #4a90e2;
  margin-top: 8px;
  margin-bottom: 8px;
}

.myCourseTitle {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.38;
  color: #4a4a4a;
  margin-bottom: 0px;

  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* min-height: 35px;
  max-height: 43px; */
}

.recCourseImage {
  width: 100%;
  height: 200px;
}

.recInstructor {
  font-size: 14px;
  line-height: 1.57;
  color: #9b9b9b;
  margin-top: 8px;
  margin-bottom: 8px;
}

.v-card > *:first-child:not(.v-btn):not(.v-chip) {
  border-top-left-radius: unset;
  border-top-right-radius: unset;
}
</style>
